import { useMutation } from "@apollo/client";
import { InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables } from "@ctypes";
import { INITIATE_RESET_PASSWORD } from "@graphql";

export const useInitiateResetPassword = () => {
  return useMutation<InitiateResetPasswordMutation, InitiateResetPasswordMutationVariables>(
    INITIATE_RESET_PASSWORD,
  );
};
